import { lazy } from 'react'

export const StartJourney = lazy(() => import('./v1/StartJourney'))
export const StartJourneyV2 = lazy(() => import('./v2/StartJourneyV2'))
